import { render } from "./WorkshopCell.vue?vue&type=template&id=0908cd80&scoped=true"
import script from "./WorkshopCell.vue?vue&type=script&lang=js"
export * from "./WorkshopCell.vue?vue&type=script&lang=js"

import "./WorkshopCell.vue?vue&type=style&index=0&id=0908cd80&scoped=true&lang=css"

import exportComponent from "/container/application/releases/20260729235012/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0908cd80"]])

export default __exports__